import { Dispatch, SetStateAction } from 'react';
import { TFunction } from 'i18next';

import fetchAutocompleteResults from 'lib/location/Autocomplete';
import Prediction from 'lib/location/Locations/Prediction';
import geocodeAndThen from 'lib/location/geocodeAndThen';
import { useLocationFilter } from 'lib/hooks/useSrpFilters';

import LocationAutocomplete from 'components/LocationAutocomplete';
import { CurrentLocation } from 'components/CurrentLocation';

import Geocode from 'types/Geocode';

interface LocationInputNoDialogProps {
  setIsModalOpen?: Dispatch<SetStateAction<boolean>>;
  onListItemClick?: (value: string) => void;
  onInputTap?: () => Promise<void>;
  onCurrentLocationTap?: () => Promise<void>;
  onSelectCityTap?: () => Promise<void>;
  className?: string;
}

const LocationInputNoDialog = ({
  setIsModalOpen,
  onListItemClick,
  onInputTap,
  onCurrentLocationTap,
  onSelectCityTap,
  className,
}: LocationInputNoDialogProps): JSX.Element => {
  const { setValue } = useLocationFilter();

  function updateStates(location: Geocode): void {
    const { latitude, longitude, city, stateAbbreviation } = location;
    setValue({
      latitude,
      longitude,
      city,
      stateCode: stateAbbreviation,
    });
    setIsModalOpen?.(false);
    onListItemClick?.(`${location.city}, ${location.stateAbbreviation}`);
  }

  function onSelect(prediction: Prediction): void {
    geocodeAndThen(prediction, updateStates);
  }

  return (
    <LocationAutocomplete<Prediction>
      needsAttribution={false}
      fetchResults={fetchAutocompleteResults}
      onSelect={onSelect}
      currentLocation={
        <CurrentLocation onLocated={updateStates} onCurrentLocationTap={onCurrentLocationTap} />
      }
      onInputTap={onInputTap}
      onSelectCityTap={onSelectCityTap}
      className={className}
    />
  );
};

export function getLocationLabel(
  t: TFunction,
  location?: { city?: string; stateCode?: string }
): string {
  return location?.city && location?.stateCode
    ? `${location.city}, ${location.stateCode}`
    : t('srp.locationFilter.selectLocation').substring(0, 19);
}

export default LocationInputNoDialog;
